import { l as layout } from "./layout-store.js";
import "./preact-core.js";
class ShopifyCart extends HTMLElement {
  constructor() {
    super();
    this.setting = "cart";
    this.cartNoteEnabled = false;
    this.busy = false;
    this.updatingLineItem = null;
    this.regularItem = [];
    this.layout = layout;
    this.ageVerificationCheckbox = null;
    this.checkoutBtn = null;
    this.cartNoteTextarea = null;
    this.giftNoteTextarea = null;
    this.noteUpdateTimeout = null;
    this.cartObserver = null;
    this.getCart();
  }
  connectedCallback() {
    this.setupAgeVerification();
    this.setupCartNotes();
    this.observeCartChanges();
  }
  disconnectedCallback() {
    if (this.cartObserver) {
      this.cartObserver.disconnect();
    }
    if (this.noteUpdateTimeout) {
      clearTimeout(this.noteUpdateTimeout);
    }
  }
  observeCartChanges() {
    if (this.cartObserver) {
      this.cartObserver.disconnect();
    }
    this.cartObserver = new MutationObserver(() => {
      this.setupAgeVerification();
      this.setupCartNotes();
    });
    this.cartObserver.observe(this, { childList: true, subtree: true });
  }
  async getCart() {
    this.busy = true;
    this.layout.fetchCart().then(() => {
      this.busy = false;
      this.setupAgeVerification();
      this.setupCartNotes();
    });
  }
  setupAgeVerification() {
    this.ageVerificationCheckbox = this.querySelector(
      "#age-verification-checkbox"
    );
    this.checkoutBtn = this.querySelector(".checkout-btn");
    if (this.ageVerificationCheckbox && this.checkoutBtn) {
      this.updateCheckoutButtonState();
      this.ageVerificationCheckbox.addEventListener("change", () => {
        this.updateCheckoutButtonState();
      });
      this.checkoutBtn.addEventListener("click", (e) => {
        var _a;
        if (!((_a = this.ageVerificationCheckbox) == null ? void 0 : _a.checked)) {
          e.preventDefault();
          this.showAgeVerificationError();
        }
      });
    }
  }
  updateCheckoutButtonState() {
    if (!this.ageVerificationCheckbox || !this.checkoutBtn) return;
    const isVerified = this.ageVerificationCheckbox.checked;
    if (isVerified) {
      this.checkoutBtn.classList.remove("btn--disabled");
      this.checkoutBtn.removeAttribute("data-disabled");
      this.checkoutBtn.style.opacity = "1";
      this.checkoutBtn.style.pointerEvents = "auto";
    } else {
      this.checkoutBtn.classList.add("btn--disabled");
      this.checkoutBtn.setAttribute("data-disabled", "true");
      this.checkoutBtn.style.opacity = "0.5";
      this.checkoutBtn.style.pointerEvents = "none";
    }
  }
  showAgeVerificationError() {
    const existingError = this.querySelector(".age-verification-error");
    if (existingError) {
      existingError.remove();
    }
    const errorMsg = document.createElement("div");
    errorMsg.className = "age-verification-error text-red-500 text-detail mt-5";
    errorMsg.textContent = "Please confirm that you are 18 years or over to proceed to checkout.";
    const ageVerificationDiv = this.querySelector(".age-verification");
    if (ageVerificationDiv) {
      ageVerificationDiv.appendChild(errorMsg);
      setTimeout(() => {
        errorMsg.remove();
      }, 5e3);
    }
  }
  setupCartNotes() {
    this.cartNoteTextarea = this.querySelector("#cart-note");
    this.giftNoteTextarea = this.querySelector("#gift-note");
    if (this.cartNoteTextarea) {
      this.parseExistingNotes();
      this.cartNoteTextarea.addEventListener("input", () => {
        this.debouncedUpdateCartNote();
      });
    }
    if (this.giftNoteTextarea) {
      this.giftNoteTextarea.addEventListener("input", () => {
        this.debouncedUpdateCartNote();
      });
    }
  }
  parseExistingNotes() {
    if (!this.cartNoteTextarea) return;
    const currentNote = this.cartNoteTextarea.value;
    const giftNoteMarker = "Gift Note:";
    if (currentNote.includes(giftNoteMarker)) {
      const parts = currentNote.split(giftNoteMarker);
      const regularNote = parts[0].trim();
      const giftNote = parts[1] ? parts[1].trim() : "";
      this.cartNoteTextarea.value = regularNote;
      if (this.giftNoteTextarea) {
        this.giftNoteTextarea.value = giftNote;
      }
    }
  }
  debouncedUpdateCartNote() {
    if (this.noteUpdateTimeout) {
      clearTimeout(this.noteUpdateTimeout);
    }
    this.noteUpdateTimeout = setTimeout(() => {
      this.updateCartNote();
    }, 500);
  }
  async updateCartNote() {
    if (!this.cartNoteTextarea) return;
    let finalNote = this.cartNoteTextarea.value.trim();
    if (this.giftNoteTextarea && this.giftNoteTextarea.value.trim()) {
      const giftNote = this.giftNoteTextarea.value.trim();
      finalNote = finalNote ? `${finalNote}

Gift Note: ${giftNote}` : `Gift Note: ${giftNote}`;
    }
    try {
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          note: finalNote
        })
      });
      if (!response.ok) {
        throw new Error("Failed to update cart note");
      }
    } catch (error) {
      console.error("Error updating cart note:", error);
    }
  }
  close() {
    this.layout.slideover.value = null;
  }
}
if (!customElements.get("shopify-cart")) {
  customElements.define("shopify-cart", ShopifyCart);
}
export {
  ShopifyCart,
  ShopifyCart as default
};
